import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './services/auth.service';

export const PARAM_PROPRIEDADE = 'propriedade';

/**
 * Ativa a propriedade indicada por `?propriedade=` antes de abrir a tela.
 */
export const propriedadeDoLinkGuard: CanActivateChildFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const bruto = route.queryParamMap.get(PARAM_PROPRIEDADE);

  if (bruto === null) return true;

  const urlLimpa = () => {
    const arvore = router.parseUrl(state.url);
    delete arvore.queryParams[PARAM_PROPRIEDADE];

    return arvore;
  };

  const id = Number(bruto);

  // Valor inválido não deve derrubar a navegação: a tela ainda pode ser a
  // certa para a propriedade já ativa.
  if (!Number.isInteger(id) || id <= 0) return urlLimpa();

  if (id === auth.propriedadeAtual) return urlLimpa();

  return auth.selecionarPropriedadeAtiva(id).pipe(
    map(() => {
      auth.setPropriedadeAtual(id);

      return urlLimpa();
    }),
    catchError(() => of(router.createUrlTree(['/sem-acesso']))),
  );
};